import * as React from "react";
import { styled } from "styled-components";

import { ButtonVariants, NavigateButton } from "affinityUI/elements/button";
import { Layout } from "affinityUI/structures/layout";

const Wrapper = styled.div`
  margin-bottom: 2rem;
`;

export const RecoverPasswordSuccess: React.FC = () => {
  return (
    <Layout title="Please check your inbox" publicLayout>
      <Wrapper>
        Click the link in the email we&apos;ve just sent to reset your password. It may take a few minutes to arrive.
      </Wrapper>
      <NavigateButton to="/login" variant={ButtonVariants.SECONDARY}>
        Log in
      </NavigateButton>
    </Layout>
  );
};
